import {action} from "typesafe-actions";
import {ActionsTypes} from './types';

export const showLoading = () => action(ActionsTypes.SHOW);

export const hideLoading = () => action(ActionsTypes.HIDE);